module.exports = __webpack_public_path__ + "static/media/tr.265d2a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tr.png
// module id = 2003
// module chunks = 0